<template>
  <div>
    <div v-if = "name !== ''" :key="name" class="modal-container">
      <div v-if="!fullScreen" class="modal-content"
           :style="{width: computedWidth, height: 'fit-content'}">
        <div class="modal-header">
          <v-btn class="modal-close-button"
                 :ripple="false"
                 icon
                 id="no-background-hover"
                 @click="changeName">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
          <div>
            <h3 class="modal-title">{{this.name}}</h3>
            <span>{{this.address}}</span>
            <div v-if="!isFactory" style="padding-top: 5px; padding-bottom: 5px" v-html="formattedHint"></div>
          </div>
        </div>
        <div v-if="!isFactory" class="modal-body">
          <v-row style="justify-content: center; padding-bottom: 10px">
            <tooltip-item
                iconClass="mr-2"
                tooltipText="Температура"
                mdi="mdi-thermometer"
                :infoStyle="{paddingRight: '20px'}"
                :infoText="lookingForMinus"
            />
            <tooltip-item
                iconClass="mr-2"
                tooltipText="Скорость и направление ветра"
                mdi="mdi-weather-windy"
                :infoStyle="{paddingRight: '20px'}"
                :infoText="this.windSpeed + ' м/c, ' + convertWindDirection(this.windDirection)"
            />
            <tooltip-item
                iconClass="mr-2 mdi--humidity-outline"
                tooltipText="Влажность воздуха"
                mdi=""
                :infoStyle="{paddingRight: '20px'}"
                :infoText="this.airHumidity.toString()"
            />
            <tooltip-item
                iconClass="mr-2 mdi--gauge"
                tooltipText="Атмосферное давление"
                mdi=""
                :infoStyle="{paddingRight: '20px'}"
                :infoText="this.atPressure.toString()"
            />
          </v-row>
          <v-row class="indicator-row">
              <span v-if="!loadingPost">Значение показателя{{this.concentration}} </span>
          </v-row>
          <discreteness-component v-if="!loadingPost" :discr="preSelected.discr"/>
          <div v-if="!loadingPost">
            <select-period-and-sensor :post-id="postId"
                                      :sensors="sensors"
                                      :pre-selected ="preSelected"/>
          </div>
          <loader v-else-if="loadingPost" message="Идёт загрузка данных"/>
          <v-row class="chart-row">
            <Bar v-if="hasData"
                 :key="chartKey"
                 :options="chartOptions"
                 :data="chartData">
            </Bar>
            <loader v-else-if="loading" message="Идёт загрузка данных"/>
            <b v-else-if="error !== ''">{{error}}</b>
            <b v-else>Нет данных за выбранный период</b>
          </v-row>
          <div v-if="hasData" class="fullscreen-button-container">
            <v-btn
               id="no-background-hover"
               class="fullscreen-button"
               small icon :ripple="false"
               @click="switchFullScreen()">
              <v-icon>mdi-arrow-top-right-bottom-left</v-icon>
            </v-btn>
          </div>
        </div>
        <div v-else>
          <iframe class="modal-iframe" :style="{width: computedWidth, height: '400px'}" :src=this.frameSrc />
        </div>
      </div>
      <div v-if="fullScreen" class="modal-full-screen-content">
        <v-btn id="no-background-hover" style="padding-top: 10px" :ripple="false" icon  @click="switchFullScreen">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
        <v-row class="chart-row">
          <Bar :options="chartOptions" :data="chartData" />
        </v-row>
      </div>
    </div>
    <div v-if="error !== ''" class="modal-container">
      <div class="err-content">
        <span> {{error}} </span>
        <v-btn :ripple="false" icon @click="error = ''">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

import {Bar} from 'vue-chartjs'
import DiscretenessComponent  from "@/components/DiscretenessComponent.vue";
import SelectPeriodAndSensor from "@/components/SelectPeriodAndSensor.vue";
import {isMobile} from "mobile-device-detect";
import {bus} from "@/main";
import 'chartjs-adapter-moment'
import 'moment/locale/ru';
import moment from "moment";
import zoomPlugin from 'chartjs-plugin-zoom';
import Chart from 'chart.js/auto'
import Loader from "@/components/LoaderComponent.vue";
import axios from "axios";
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiWaterPercent } from '@mdi/js';
import TooltipItem from "@/components/TooltipItem.vue";

moment.locale("ru")
Chart.register(zoomPlugin);


export default {
  components: {TooltipItem, Loader, SelectPeriodAndSensor, DiscretenessComponent, Bar, SvgIcon},
  data: () => ({
    loading: true,
    loadingPost: true,
    hasData: false,
    fullScreen: false,
    error: "",
    concentration: "",
    chartOptions: {},
    chartData: {},
    chartKey: false,
    chartResponse: {},
    hint: "",
    name: "",
    temperature: "",
    windDirection: "",
    atPressure: "",
    airHumidity: "",
    windSpeed: "",
    isFactory: false,
    postId: 0,
    address: "",
    sensors: [],
    frameSrc: "",
    preSelected: {
      sensorName: "",
      period: 1,
      discr: 1
    },
    path: mdiWaterPercent,
  }),
  computed: {
    computedWidth () {
      if (isMobile) {
        return ''
      } else {
        return '510px'
      }
    },
    lookingForMinus() {
      return this.temperature.toString().includes('-') ? this.temperature :  '+ ' + this.temperature;
    },
    formattedHint() {
      let text = this.hint;
      const word = 'не зафиксировано';
      const replacement = `<span class="highlight">${word}</span>`;

      const regex = new RegExp(word, 'g');
      if(regex.test(text)) {
        return text.replace(regex, replacement);
      }
      return text;
    }
  },
  methods: {
    changeName() {
      this.name = ""
      this.error = ""
      bus.$emit('update-usePointId')
    },
    switchFullScreen() {
      this.fullScreen = !this.fullScreen
    },
    chartUpdate(chart) {
      this.chartData = chart.data
      this.chartOptions = chart.options
      let belowCount
      let higherCount
      if (this.chartData.datasets.length === 1) {
        belowCount = this.chartData.datasets[0].data.filter((x) => x === null).length;
      }
      if (this.chartData.datasets.length > 1) {
        belowCount = this.chartData.datasets[0].data.filter((x) => x === null).length;
        higherCount = this.chartData.datasets[1].data.filter((x) => x === null).length;
      }

      if (belowCount === this.chartData.labels.length && higherCount === this.chartData.labels.length) {
        this.concentration = ""
        this.hasData = false
      } else {
        if (this.chartData.datasets[0].unit === "C") {
          this.concentration = ", ℃"
        } else {
          this.concentration = ", " + this.chartData.datasets[0].unit
        }
        this.hasData = true
        this.chartKey = !this.chartKey
      }

      this.loading = false
    },
    convertWindDirection(angle) {
      const directions = ['С', 'СВ', 'В', 'ЮВ', 'Ю', 'ЮЗ', 'З', 'СЗ'];
      const index = Math.round(angle / 45) % 8;
      return directions[index];
    },
    loadSensorList(point) {
      let id = point.id
      this.hint = point.hint
      this.loadingPost = true
      this.name = "Загрузка..."
      this.address = ""
      this.temperature = point.temperature
      this.windDirection = point.windDirection
      this.atPressure = point.atPressure
      this.windSpeed = point.windSpeed
      this.airHumidity = point.airHumidity
      this.chartClean()

      axios
        .post("/air/sensors-list", null, {params: {id}})
        .then(response => {
          this.name = point.extendName
          this.isFactory = false
          this.postId = point.id
          this.address = point.address
          this.sensors = response.data.sensors
          this.loadingPost = false

          bus.$emit('change-loading')
        })
        .catch(err => {
          this.error = "Технические неполадки, скоро всё наладится"
          this.loadingPost = false

          bus.$emit('change-loading')
          console.log(err)
        })
    },
    loadFactory(point) {
      this.isFactory = true
      this.name = point.extendName
      this.address = point.address
      this.frameSrc = "http://factory-check.krasecology.ru/#/" + point.id
    },
    chartClean() {
      this.chartData = {}
      this.chartOptions = {}
      this.hasData = false
      this.loading = true
      this.error = ""
    },
  },
  created() {
    bus.$off('chart-data')
    bus.$on('chart-data', (chart) => {
      if (!this.loadingPost) {
        this.chartUpdate(chart)
      }
    })

    bus.$off('clean-chart')
    bus.$on('clean-chart', this.chartClean)

    bus.$on('load-sensors', point => {
      this.fullScreen = false
      this.loadSensorList(point)
    })

    bus.$off('load-factory')
    bus.$on('load-factory', point => {
      this.fullScreen = false
      this.loadFactory(point)
    })

    bus.$off('pre-install-selected')
    bus.$on('pre-install-selected', (selected) => {
      this.preSelected.sensorName = selected.name
      this.preSelected.period = selected.period
      this.preSelected.discr = selected.discr
    })

    bus.$off('err-listen')
    bus.$on('err-listen', (err) => {
      this.error = err.text
      this.loading = false
    })
  }
}
</script>

<style>
.modal-container {
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row-reverse;
}

.modal-content {
  box-shadow: 0 0 11px 1px #ccc;
  border: 1px solid lightgrey;
  position: absolute;
  background: #ffffff;
  padding-bottom: 25px;
}

.err-content {
  box-shadow: 0 0 11px 1px #ccc;
  border: 1px solid lightgrey;
  position: absolute;
  background: #ffffff;
  padding: 20px;
}

.modal-header {
  display: flex;
}

.modal-close-button {
  padding-top: 10px;
}

.modal-title {
  padding-top: 10px;
}

.modal-body {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
}

.indicator-row {
  margin-top: 1px;
  justify-content: center;
}

.chart-row {
  justify-content: space-around;
}

.fullscreen-button-container {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
}

.fullscreen-button {
  width: fit-content;
}

.modal-full-screen-content {
  box-shadow: 0 0 11px 1px #ccc;
  border: 1px solid lightgrey;
  position: absolute;
  background: #ffffff;
  padding-bottom: 25px;
  width: 1000px;
  height: 600px;
}

.highlight {
  color: green;
}
</style>